var _style, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64.7 64.7",
    style: {
      enableBackground: "new 0 0 64.7 64.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#629EDA;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 64.7,
    height: 64.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.4,13.8c-9.7,0-17.5,7.8-17.5,17.5s7.8,17.5,17.5,17.5S49.9,41,49.9,31.4c0,0,0,0,0,0 C49.9,21.7,42,13.8,32.4,13.8z M44.9,33.5H32.3c-0.6,0-1.1-0.5-1.1-1.1V19.2c-0.1-0.6,0.4-1.2,1-1.2c0.6-0.1,1.2,0.4,1.2,1 c0,0.1,0,0.1,0,0.2v12h11.5c0.6,0,1.1,0.5,1.1,1.1C46,32.9,45.5,33.4,44.9,33.5L44.9,33.5L44.9,33.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.8df0afa842da888e15fbdfa8a7fba767.svg";
export { ForwardRef as ReactComponent };